import Config from "../../config/Config";
import {
  createArrayEntityFromObject,
  createQueryUrl,
  getEntity,
} from "../../config/global";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlDev;
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};
export const getMutation = (startDate, endDate, page, size) => {
  let url = `${baseUrlDev}python/balance/mutation?date=${startDate}/${endDate}&coa=21-200&page=${page}&size=${size}&sort=dateTime,desc`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${bearer()}` },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMutationOlder = (startDate, endDate, page, size) => {
  let url = `${baseUrlDev}python/balance/old/mutation?date=${startDate}/${endDate}&coa=21-200&page=${page}&size=${size}&sort=dateTime,desc`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${bearer()}` },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMutationByType = (data, page, size, transaction_type) => {
  let url = `${baseUrlDev}mob_user/get_mutasi_saldo?size=${size}&page=${page}&transactionType=${transaction_type}&dir=-1`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getTransactionType = (data) => {
  let url = `${baseUrlDev}mob_user/transaction_type`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const executeOrder = (data, token) => {
  let url = `${baseUrlDev}commerce/member/order`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
          "Re-Authentication": token,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
